export default class GridMultiReportManager {

    baseUrl;
    statusUrl;
    downloadUrl;
    domContainer;

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    async fetchJson(url) {
        const fetchOptions = {
            credentials: 'include'
        };
        const response = await fetch(url, fetchOptions);
        const json = await response.json();
        return json;
    }

    getParentOfType(parentNodeName, elem, initialElem = elem) {
        // Stop case : we found null or an object of the right type
        if (elem === null || (elem !== initialElem && elem.nodeName === parentNodeName)) {
            return elem;
        }

        // Otherwise, we try to find a parent recursively
        let parent = null;
        if (elem instanceof ShadowRoot) {
            parent = elem.host;
        } else {
            parent = elem.parentNode;
        }

        return this.getParentOfType(parentNodeName, parent, elem);
    }

    displayError() {
        const icon = document.createElement('small');
        icon.className = 'fa fa-fw fa-exclamation-triangle';

        const span = document.createElement('span');
        span.className = 'text-danger';
        span.innerHTML = 'Fehler bei der Generierung';

        this.domContainer.innerHTML = '';
        this.domContainer.appendChild(icon);
        this.domContainer.appendChild(span);
    }

    displayProgress(nbDone, nbTotal) {
        const icon = document.createElement('small');
        icon.className = 'fa fa-fw fa-refresh fa-spin';

        const span = document.createElement('span');
        span.innerHTML = (nbDone) ? `wird generiert... [${nbDone}/${nbTotal}]` : 'wird generiert...';

        this.domContainer.innerHTML = '';
        this.domContainer.appendChild(icon);
        this.domContainer.appendChild(span);
    }

    displayDownload() {
        const downloadLink = document.createElement('a');
        downloadLink.href = this.downloadUrl;
        downloadLink.target = '_blank';
        downloadLink.innerHTML = 'Herunterladen';

        const icon = document.createElement('small');
        icon.className = 'fa fa-fw fa-download';

        this.domContainer.innerHTML = '';
        this.domContainer.appendChild(icon);
        this.domContainer.appendChild(downloadLink);
    }

    async updateStatus() {
        try {
            const status = await this.fetchJson(this.statusUrl);
            const nbDone = status.prints.filter(p => p.done === true).length;
            const nbError = status.prints.filter(p => p.status === 'error').length;
            if (nbError > 0) {
                this.displayError();
            }
            else if (nbDone < status.prints.length) {
                this.displayProgress(nbDone, status.prints.length);
                setTimeout(() => this.updateStatus(), 1000); // update every 1 sec
            }
            else {
                // Everything is done, display the download url
                this.displayDownload();
            }
        } catch {
            // Try again
            setTimeout(() => this.updateStatus(), 1000);
        }
    }

    async multireport(url, domElement) {
        const parent = this.getParentOfType('TD', domElement);
        if (parent) {
            this.domContainer = parent;
            this.displayProgress();

            try {
                const response = await this.fetchJson(url);
                this.downloadUrl = `${this.baseUrl}${response.downloadUrl}`;
                this.statusUrl = `${this.baseUrl}${response.statusUrl}`;
                this.updateStatus();
            }
            catch {
                this.displayError();
            }
        }
        else {
            throw Error('Parent container not found: cannot show print status.');
        }
    }
}
